import { render, staticRenderFns } from "./form-sad-subitems.vue?vue&type=template&id=23acebf4&scoped=true&"
import script from "./form-sad-subitems.vue?vue&type=script&lang=js&"
export * from "./form-sad-subitems.vue?vue&type=script&lang=js&"
import style0 from "./form-sad-subitems.vue?vue&type=style&index=0&id=23acebf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acebf4",
  null
  
)

export default component.exports